import { ReactNode } from "react";
import { Asterisk, Card, fontMedium, RadioList, useFeatureFlags } from "swing-components";

import { translate } from "~utils";

import type { PayCode } from "../../utils";

type PaycodeReasonsProps = {
  reason?: PayCode["payCode"];
  onReasonChange: (reason: PayCode["payCode"]) => void;
  /** @default false */
  isDisabled?: boolean;
};

export function PaycodeReasons(props: PaycodeReasonsProps) {
  const { reason, onReasonChange, isDisabled = false } = props;
  const { flags } = useFeatureFlags();

  /****** Constants ********/
  const options: Array<{
    label: string;
    value: NonNullable<PayCode["payCode"]>;
    description: ReactNode;
  }> = [
    // {
    //   label: translate("TIMESHEET_PAYCODE_SICK_LEAVE_LABEL"),
    //   value: "Sick",
    //   description: (
    //     <span
    //       dangerouslySetInnerHTML={{
    //         __html: translate("TIMESHEET_PAYCODE_SICK_LEAVE_DESCRIPTION"),
    //       }}
    //     />
    //   ),
    // },
    {
      label: translate("TIMESHEET_PAYCODE_MRT_LABEL"),
      value: "Mandated Reporter Training",
      description: translate("TIMESHEET_PAYCODE_MRT_DESCRIPTION"),
    },
    {
      label: translate("TIMESHEET_PAYCODE_COC_LABEL"),
      value: "Admin New Hire Paperwork",
      description: (
        <span
          dangerouslySetInnerHTML={{
            __html: translate("TIMESHEET_PAYCODE_COC_DESCRIPTION"),
          }}
        />
      ),
    },
  ];

  if (flags.swingSubsTimesheetHpt) {
    options.push({
      label: translate("TIMESHEET_PAYCODE_HPT_LABEL"),
      value: "Harassment Prevention Training",
      description: translate("TIMESHEET_PAYCODE_HPT_DESCRIPTION"),
    });
  }

  /****** Render ********/
  return (
    <Card>
      <div css={{ display: "flex", alignItems: "center", marginBottom: 16 }}>
        <span css={{ ...fontMedium({ fontWeight: 600 }) }}>
          {translate("TIMESHEET_REASONS_TITLE")}
          <Asterisk />
        </span>
      </div>
      <RadioList
        groupName="timecard-paycode-entry-reason"
        options={options}
        value={reason}
        onChange={onReasonChange}
        status={isDisabled ? "disabled" : "enabled"}
      />
    </Card>
  );
}
